"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.maxby"));

var _moment = _interopRequireDefault(require("moment"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _components = require("../../../../../common/components");

var _utils = require("../../../../../common/utils");

require("../styles/_video-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var calculateAssetsTotalSize = (0, _lodash2.default)(function (assets) {
  var assetsTotalSize = assets.reduce(function (total, asset) {
    if (!asset || !asset.metaData) {
      return total;
    }

    try {
      var assetSize = JSON.parse(asset.metaData).size;
      return total + assetSize;
    } catch (e) {
      return total;
    }
  }, 0);
  return (0, _getDisplayBytes.default)(assetsTotalSize);
});

var getEndTime = function getEndTime(latestVersion) {
  var RUSH_EDIT = latestVersion.appliedAddons.RUSH_EDIT,
      dueDate = latestVersion.dueDate;
  var rushHours = (0, _utils.getRushValue)(RUSH_EDIT);
  return (0, _moment.default)(dueDate, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).add(rushHours, 'hours').format('Do MMMM YYYY [at] hh:mm A');
};

var getSubmitDate = function getSubmitDate(latestVersion) {
  var submittedAt = latestVersion.submittedAt;
  return (0, _moment.default)(submittedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('[on] Do MMMM YYYY [at] hh:mm A');
};

function VideoDetails(_ref) {
  var video = _ref.video,
      assets = _ref.assets,
      organisation = _ref.organisation,
      owner = _ref.owner;
  var outputs = video.outputs;
  var masterOutput = outputs.find(function (_ref2) {
    var isMaster = _ref2.isMaster;
    return isMaster;
  });
  var difficulty = masterOutput.difficulty;
  var latestVersion = (0, _lodash.default)(masterOutput.versions, 'versionNumber');
  var userName = (0, _getUserFullName.default)(owner);
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: "video-details"
    }, organisation && /*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
      className: "video-details__org",
      imageUrl: organisation.imageUrl,
      imageSize: "100px",
      options: []
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-details__org__title"
    }, organisation.name)), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-details__detail"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Asset Details"), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-details__detail__value"
    }, "".concat(assets.length, " Assets | ").concat(calculateAssetsTotalSize(assets)))), /*#__PURE__*/_react.default.createElement("hr", {
      className: "video-details__hr"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-details__detail"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "video-details__detail__user"
    }, "Submitted by"), owner && /*#__PURE__*/_react.default.createElement(_components.ProfileCard, {
      imageUrl: owner.imageUrl,
      name: userName,
      imageSize: 24
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-details__detail__value"
    }, getSubmitDate(latestVersion))), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-details__detail"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Expected Completion"), /*#__PURE__*/_react.default.createElement("p", {
      className: "video-details__detail__value"
    }, getEndTime(latestVersion))), /*#__PURE__*/_react.default.createElement("hr", {
      className: "video-details__hr"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "video-details__detail"
    }, /*#__PURE__*/_react.default.createElement("p", null, "Difficulty Rating"), /*#__PURE__*/_react.default.createElement(_components.DifficultyDropdown, {
      defaultValue: difficulty,
      updateDifficulty: null,
      disabled: true
    })))
  );
}

var _default = (0, _react.memo)(VideoDetails);

exports.default = _default;